import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Music, MailCheck } from "lucide-react";

export default function AdminForgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, "Envoi impossible. Réessayez."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF6F0] px-4">
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-stone-300 bg-white p-8 shadow-md sm:p-10">
          <div className="mb-8 flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded bg-[#B83227] text-white">
              <Music className="h-5 w-5" aria-hidden="true" />
            </div>
            <div>
              <p className="font-display text-xl font-bold uppercase text-[#1E1B18]">Mot de passe oublié</p>
              <p className="text-xs text-stone-500">Les Sonneurs de la Côte</p>
            </div>
          </div>

          {sent ? (
            <div data-testid="forgot-success" className="text-center">
              <MailCheck className="mx-auto h-10 w-10 text-[#B83227]" aria-hidden="true" />
              <p className="mt-4 text-sm leading-relaxed text-stone-700">
                Si un compte existe pour <strong>{email}</strong>, un e-mail avec un lien de réinitialisation vient d'être envoyé (valable 1 heure).
              </p>
              <p className="mt-2 text-xs text-stone-500">Pensez à vérifier le dossier spam.</p>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-form" className="space-y-5">
              <p className="text-sm text-stone-600">
                Saisissez l'adresse e-mail du compte administrateur : vous recevrez un lien pour choisir un nouveau mot de passe.
              </p>
              <div>
                <label htmlFor="forgot-email" className="mb-2 block text-xs font-bold uppercase text-stone-700">E-mail</label>
                <input
                  id="forgot-email"
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full rounded-lg border border-stone-300 bg-[#FAF6F0] p-3.5 text-sm focus:border-[#B83227] focus:outline-none"
                />
              </div>
              {error && (
                <p data-testid="forgot-error" className="rounded-lg bg-red-50 p-3 text-xs font-medium text-red-700">{error}</p>
              )}
              <button
                type="submit"
                data-testid="forgot-submit"
                disabled={loading}
                className="w-full rounded bg-[#B83227] px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-white shadow transition-colors duration-300 hover:bg-[#96281E] disabled:opacity-60"
              >
                {loading ? "Envoi en cours..." : "Envoyer le lien de réinitialisation"}
              </button>
            </form>
          )}
        </div>
        <p className="mt-6 text-center">
          <Link to="/admin" data-testid="back-to-login-link" className="text-xs font-bold uppercase text-stone-500 hover:text-[#B83227]">
            &larr; Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
}
